import appConfig from 'app.config'
import { useTranslation } from 'react-i18next'
import { ICustomer } from 'selfServicePortal/interfaces/i-api-customer'
import { checkIsMobile } from 'shared/utils/helpers'

export const AccountAddressFormDE_AT = (data: ICustomer) => {
	const { t } = useTranslation(['translation', 'forms'])
	const isMobile = checkIsMobile()

	return {
		fieldSetName: '',
		formName: 'CustomerInformation',
		description: '',
		collapsable: false,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				controlName: 'customer.name',
				type: 'text',
				label: t('Name'),
				value: `${data.firstName} ${data.lastName}`,
				visible: true,
				fullSize: true,
				col: 12,
				disabled: true,
			},
			{
				required: true,
				controlName: 'customer.street',
				type: 'text',
				label: t('Street'),
				value: data.street,
				visible: true,
				maxLength: 40,
				col: isMobile ? 12 : 9,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^$|^[^0-9!@#$%^&*()_+=|\\{};><?\u0400-\u04FF\uFFFD]+$',
						message: t('ValidationMsgStreet'),
					},
				],
				disabled: false,
			},
			{
				required: true,
				controlName: 'customer.houseNumber',
				type: 'text',
				label: t('Nr'),
				value: data.houseNumber,
				visible: true,
				col: isMobile ? 12 : 3,
				maxLength: 5,
				validations: [
					{
						code: 'MustMatchPattern',
						value:
							appConfig.country === 'de'
								? '^[a-zA-Z0-9]*$'
								: '^[a-zA-Z0-9/]*$',
						message: t('ValidationMsgOnlyNumbersAndLetters'),
					},
				],
			},
			{
				required: true,
				controlName: 'customer.postalCode',
				type: 'number',
				label: t('Zip'),
				value: data.postalCode,
				visible: true,
				col: isMobile ? 12 : 4,
				maxLength: appConfig.country === 'de' ? 5 : 4,
				validations: [
					{
						code: 'MustMatchPattern',
						value:
							appConfig.country === 'de'
								? '\\b\\d{5}\\b'
								: '\\b\\d{4}\\b',
						message: t('ValidationMsgZip'),
					},
				],
			},
			{
				required: true,
				controlName: 'customer.city',
				type: 'text',
				label: t('City'),
				value: data.city,
				visible: true,
				col: isMobile ? 12 : 8,
				maxLength: 30,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^$|^[^0-9.,\\-!@#$%^&*()_+=|\\{};><?\u0400-\u04FF\uFFFD]+$',
						message: t('ValidationMsgStreet'),
					},
				],
			},
		],
	}
}

export const AccountEmailFormDE_AT = (data: ICustomer) => {
	const { t } = useTranslation(['translation', 'forms'])
	return {
		fieldSetName: '',
		formName: 'AccountEmailForm',
		description: '',
		collapsable: false,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				controlName: 'customer.email',
				type: 'email',
				label: t('Email'),
				value: data.email,
				visible: true,
				fullSize: true,
				col: 12,
				maxLength: 40,
			},
		],
	}
}

export const AccountMobilePhoneFormDE_AT = (data: ICustomer) => {
	const { t } = useTranslation(['translation', 'forms'])
	return {
		fieldSetName: '',
		formName: 'AccountMobilePhoneForm',
		description: '',
		collapsable: false,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				controlName: 'customer.mobilePhoneNumber',
				type: 'tel', //change back to phoneNumber when formbuilder is updated
				label: t('PhoneNumber'),
				value: data.mobilePhoneNumber,
				visible: true,
				fullSize: true,
				col: 12,
				maxLength: 15,
				countryCode: 'DE',
				wrapperClass: 'tel-container-wrapper ' + appConfig.country, //Add this class for now when using type "tel"
			},
		],
	}
}
